import axios from 'axios';
import { toast } from 'react-toastify';
import React from 'react';
import { Trans } from 'react-i18next';

let _subdomain = 'wetelo';
// const rootDomain = 'localhost:3344'; let domain = 'localhost:3343'; const ssl = false;
// const rootDomain = 'testal.yarea.io'; const domain = window.location.host; const ssl = true;
const rootDomain = 'www.yarea.io'; const domain = window.location.host; const ssl = true;

if (domain.indexOf('localhost') === false) {
  [_subdomain] = domain.split('.');
}

if (_subdomain) {
  axios.defaults.headers.common.Subdomain = _subdomain;
}

const baseUrl = `http${ssl ? 's' : ''}://${domain}`;
const baseRootUrl = `http${ssl ? 's' : ''}://${rootDomain}`;
const apiUrl = `${baseUrl}/api`;

const setToken = (token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

const clearToken = () => {
  axios.defaults.headers.common.Authorization = '';
};

const get = (methodUrl, params) => axios.get(apiUrl + methodUrl, { params });
const post = (methodUrl, params) => axios.post(apiUrl + methodUrl, params);
const put = (methodUrl, params) => axios.put(apiUrl + methodUrl, params);
const destroy = (methodUrl, params) => axios.delete(apiUrl + methodUrl, { params });

const catchError = async (func, checkLiveApi = true) => {
  try {
    return await func();
  } catch (e) {
    if (typeof e.response === 'undefined') {
      toast.error((<Trans>Server is unavailable</Trans>));
    } else {
      const rData = e.response.data;
      if (checkLiveApi && e.response.status === 502) {
        const data = await axios.get(baseRootUrl + '/subscriber');
        return await catchError(func, false);
      }
      if (rData && rData.message === 'Forbidden' && rData.reload) {
        toast.error((<Trans>Forbidden</Trans>));
        return window.location.reload();
      } else {
        toast.error((<Trans>Internal server error</Trans>));
      }
    }
    throw e;
  }
};

export default {
  domain,
  get subdomain() { return _subdomain; },
  set subdomain(subdomain) { _subdomain = subdomain; },
  baseUrl,
  baseRootUrl,
  apiUrl,
  setToken,
  clearToken,
  get,
  post,
  put,
  destroy,
  catchError,
};



// WEBPACK FOOTER //
// ./src/services/api.service.js